import { render, staticRenderFns } from "./SfLink.vue?vue&type=template&id=88a0b322&"
import script from "./SfLink.vue?vue&type=script&lang=js&"
export * from "./SfLink.vue?vue&type=script&lang=js&"
import style0 from "./SfLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports